import { brand } from "../brands/index.js";
import { zh, type Strings } from "./zh.js";
import { en } from "./en.js";

const registry: Record<string, Strings> = { zh, en };

export const t: Strings = registry[brand.lang] ?? zh;
export type { Strings } from "./zh.js";
